// =============== home page copy code js
const codecopy = document.querySelector(".copy-code-right");
const closeicons = document.querySelector(".discount-bar-close-icon");
const mainClass = document.querySelector(".coupan-code");
if (codecopy) {
  codecopy.addEventListener("click", function () {
    let copyText = document.querySelector(".copy-code-left").innerText;

    let tempTextArea = document.createElement("textarea");
    tempTextArea.value = copyText;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand("copy");
    document.body.removeChild(tempTextArea);
  });
}
closeicons?.addEventListener("click", function () {
  mainClass.classList.remove("close-bar");
});


const radios = document.querySelectorAll('.pack-radio');
const quantityField = document.querySelector('[custom-quantity-field]');

radios?.forEach(function (radio) {
  radio.addEventListener('change', function () {
    const selectedQty = this.value;
    if (quantityField) {
      quantityField.value = selectedQty;
    }

    document.querySelectorAll('.option-card').forEach(card => card.classList.remove('selected'));
    this.closest('.option-card').classList.add('selected');
  });

  if (radio.checked && quantityField) {
    quantityField.value = radio.value;
    radio.closest('.option-card').classList.add('selected');
  }
});




// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}
// accordions js end
(function() {
  faq_taggol();
  hidejujmereview();
})();


function hidejujmereview() {
  document.querySelectorAll('[data-number-of-reviews]').forEach(el => {
    const reviewCount = parseInt(el.getAttribute('data-number-of-reviews'), 10);

    if (reviewCount === 0) {
        const parent = el?.closest('.product-item__ratings');
        if (parent) {
            parent.classList.add('hidden');  
        }
    }
});

}



// -------------- faq page  js
const faqtitle = document.querySelectorAll('.faq-btn');
faqtitle.forEach(faqtitles => {
  faqtitles.addEventListener('click', function (event) {
    event.preventDefault();

    const gettitle = this.getAttribute('data-btn-title');
    console.log(gettitle, "gettitle");
    faqtitle.forEach(btn => btn.classList.remove('active')); // Remove from all buttons
    this.classList.add('active');


    document.querySelectorAll('.faq-page-content').forEach(content => {
      content.style.display = "none";
    });

    const contentdiv = document.querySelector(`.faq-page-content[data-faq-content="${gettitle}"]`);
    console.log(contentdiv, 'contentdiv');

    if (contentdiv) {
      contentdiv.style.display = "block";
    }
   const classremove  =  document.querySelector('.dropdown-content');
    classremove.classList.remove('dropdown-active')
  });
});

document.querySelectorAll('.dropdown-button').forEach(dropdownBtn => {
  dropdownBtn.addEventListener('click', function (event) {
    event.stopPropagation(); // Prevents immediate closing when clicking button

    const closestDiv = this.closest('.dropdown');
    const dropdownContent = closestDiv.querySelector('.dropdown-content');

    // Close all other dropdowns
    document.querySelectorAll('.dropdown-content').forEach(content => {
      if (content !== dropdownContent) {
        content.classList.remove('dropdown-active');
      }
    });

    dropdownContent.classList.toggle('dropdown-active');
  });
});

document.addEventListener('click', function (event) {
  document.querySelectorAll('.dropdown-content').forEach(content => {
    if (!content.closest('.dropdown').contains(event.target)) {
      content.classList.remove('dropdown-active');
    }
  });
});
function toggleDropdown() {
  var dropdownMenu = document.getElementById("dropdownMenu");
  var dropdownIcon = document.getElementById("dropdownIcon");
  if (dropdownMenu.style.display === "block") {
    dropdownMenu.style.display = "none";
    dropdownIcon.style.transform = "rotate(0deg)";
  } else {
    dropdownMenu.style.display = "block";
    dropdownIcon.style.transform = "rotate(180deg)";
  }
}

// ====== faq page accordian  ======
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".faq-page_main_wrapper .accordion").forEach(function (accordion) {
    accordion.addEventListener("click", function () {
      const isOpen = accordion.classList.contains("is-open");
      document.querySelectorAll(".faq-page_main_wrapper .accordion").forEach(function (item) {
        item.classList.remove("is-open");
        const content = item.nextElementSibling;
        if (content) content.style.maxHeight = "0px";
      });
      if (!isOpen) {
        accordion.classList.add("is-open");
        const content = accordion.nextElementSibling;
        if (content) content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
});




// component-predictive-search popup main serch

class CustomSerchPopup extends HTMLElement {
  constructor() {
    super();
	this.button = this.querySelector('a') || null;
	this.main_serch = this.querySelector('search-form') || null;
  this.close_button = this.querySelector('.search_popup_close_btn') || null;
	if (!this.button && !this.main_serch) return;
	 this.button.addEventListener('click', this.onButtonClick.bind(this));
     if(this.close_button){      
        this.close_button.addEventListener('click', this.closepopup.bind(this));
      }
  }

onButtonClick(event) {
    event.preventDefault();
	this.main_serch.classList.toggle('hide');
  document.body.classList.toggle('serch-popup-open');

}

closepopup() {  
	this.main_serch.classList.add('hide');
  document.body.classList.remove('serch-popup-open');

}
}
customElements.define('custom-serch-popup', CustomSerchPopup);


const cards = document.querySelectorAll('.store-team-item');
const btn = document.getElementById('show-more-btn');
let visibleCount = 7;      
const step = 7;           

function updateButton() {
  if(btn){
    if (visibleCount >= cards.length) {
      btn.style.display = 'none'; 
    }
  } 
}

btn?.addEventListener('click', function () {
  const nextCount = Math.min(visibleCount + step, cards.length);
  for (let i = visibleCount; i < nextCount; i++) {
    cards[i].classList.remove('hidden-by-js');
  }
  visibleCount = nextCount;
  updateButton();
});

updateButton();

// Get all megamenus sort A-Z
const menus = document.getElementsByClassName('megamenu_ul');

// Loop through each menu
Array.from(menus).forEach(menu => {
  const items = Array.from(menu.getElementsByTagName('li'));

  // Sort A–Z
  items.sort((a, b) =>
    a.textContent.trim().localeCompare(b.textContent.trim())
  );

  // Clear and re-append sorted items
  menu.innerHTML = '';
  items.forEach(item => menu.appendChild(item));
});

// Initialize AOS JS
AOS.init();

function changeSlot(This){
  const free_slot_inp = This.classList.contains("free_slot_input");
  const product_slot_inp = This.classList.contains("product_slot_input");
  const free_slot = document.querySelector(".free_slot");
  const product_slot = document.querySelector(".product_slot");
  
  if(free_slot_inp){        
    free_slot?.classList.remove("hide");
    product_slot?.classList.add("hide");
    const firstSelector = free_slot?.querySelector(".slot_main_seletor");
    firstSelector?.click();
  }

  if(product_slot_inp){    
    product_slot?.classList.remove("hide");
    free_slot?.classList.add("hide");
    const firstSelector = product_slot?.querySelector(".slot_main_seletor");
    firstSelector?.click();
  }

}



// Store variants once
window.extraFeeVariants = JSON.parse(document.querySelector('.add-to-cart.button')?.getAttribute('data-add-product-var-id') || '[]');


//   // product in price base product
// function getFreeVariant(This) {  
//   // const parent_div = This.closest(".product__cart-functions");
//   // const qty_inp = parent_div.querySelector("product-quantity .product-quantity__selector");
//   const fee_product = This.getAttribute("data-add-product-var-id");
//   const qty = parseInt(This.closest(".product__cart-functions")?.querySelector("product-quantity .product-quantity__selector").value,10);

//   const target =
//     qty >= 72 ? 72 :
//     qty >= 60 ? 60 :
//     qty >= 48 ? 48 :
//     qty >= 36 ? 36 :
//     24;

//   const variants = JSON.parse(document.getElementById("gift-product").dataset.variants);
//   const variant = variants.find(v => parseInt(v.title, 10) === target);
//   console.log("variants",variants,"variant",variant)


// }

// // Store variants once
// window.extraFeeVariants = JSON.parse(
//   document.querySelector('.add-to-cart.button')
//     ?.getAttribute('data-add-product-var-id') || '[]'
// );


 function getSelectedVariantsfee() {
        const selectedVariant = document.querySelector('[data-fee-priduct-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }


function update_addons(inaput,qty) {
  const inaput_parant = inaput.closest('product-form')|| null
  if(!inaput_parant) return;
  const stack_price = inaput_parant.querySelector('[data-stack-price]')|| null
  console.log("inaput_parant",inaput_parant);
    const custom_varant = document.querySelector('#addon_varinat') || null;
    
        const varinatcheck_json_main = getSelectedVariantsfee();
    if(!custom_varant && !varinatcheck_json_main) return;
    const targetTitle =
    qty >= 84 ? '84' :
    qty >= 72 ? '72' :
    qty >= 60 ? '60' :
    qty >= 48 ? '48' :
    qty >= 36 ? '36' :
    qty >= 24 ? '24' :
    null;

    if (!targetTitle && targetTitle == '84' ) {
    custom_varant.value = ''
    if(stack_price) stack_price.innerHTML = `${theme.Currency.formatMoney(0, KROWN.settings.shop_money_format)}`
  }
    const variant = varinatcheck_json_main.find(v => v.title === targetTitle);
    console.log(variant);


    if (!variant) {
        custom_varant.value = '';
      if(stack_price) stack_price.innerHTML = `${theme.Currency.formatMoney(0, KROWN.settings.shop_money_format)}`;
       return 
  }
  if (!variant.available) {
     custom_varant.value = '';
      if(stack_price) stack_price.innerHTML = `${theme.Currency.formatMoney(0, KROWN.settings.shop_money_format)}`;
       return 
  }
  if (
    variant.inventory_management !== 'shopify' ||
    (variant.inventory_management === 'shopify' && variant.available)
  ) {
        custom_varant.value = variant.id;
          if(stack_price) stack_price.innerHTML = `${theme.Currency.formatMoney(variant.price, KROWN.settings.shop_money_format)}`;
           return 
  }

   custom_varant.value = '';
   if(stack_price) stack_price.innerHTML = `${theme.Currency.formatMoney(0, KROWN.settings.shop_money_format)}`;
    return 

}



function get_update_varinat_fro_cart(qty) {
  console.log('qty', qty);

  if (!qty) return null;
  const variants = getSelectedVariantsfee();
  const targetTitle =
    qty >= 84 ? '84' :
    qty >= 72 ? '72' :
    qty >= 60 ? '60' :
    qty >= 48 ? '48' :
    qty >= 36 ? '36' :
    qty >= 24 ? '24' :
    null;

  if (!targetTitle && targetTitle == '84' ) {
     console.log('0');
    return null;
  }
  const variant = variants.find(v => v.title === targetTitle);
  console.log(variant);
  if (!variant) {
    console.log('1');
    return null;
  }
  if (!variant.available) {
    console.log('2');
    return null;
  }
  if (
    variant.inventory_management !== 'shopify' ||
    (variant.inventory_management === 'shopify' && variant.available)
  ) {
    console.log('3');
    return variant.id;
  }

  console.log('4');
  return null;
}




  async function addtocatycust(targetVariantID, timestamp,main_varinat) {
  
      const body = new URLSearchParams({
          id: targetVariantID,
          quantity: 1,
          'properties[_auto_fee]': 'true',
          'properties[_time_stamp]': timestamp
        });


            await fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: targetVariantID,
                  quantity: 1,
                  properties: {
                    _auto_fee: 'true',
                    _time_stamp:timestamp,
                    _main_product:main_varinat
                  }
                })
              })
					.then(response => response.json())
					.then(response => {

						// console.log("response.status",response);
						if (response.status == 422 ) {							
              console.log('Request failed');
							return fetch('?section_id=helper-cart');
						} else {
              return fetch('?section_id=helper-cart');
						}
					})
					.then(response => response.text())
					.then(text => {

						const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');

            // console.log("sectionInnerHTML",sectionInnerHTML);

							const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
							const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

							if ( document.getElementById('AjaxCartForm') ) {
								const cartItems = document.getElementById('AjaxCartForm');
								cartItems.innerHTML = cartFormInnerHTML;
								cartItems.ajaxifyCartItems();
								// if ( alert != '' ) {
								// 	document.getElementById('AjaxCartForm').querySelector('form').prepend(alert);
								// }
								document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							}

						

						document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
							elm.textContent = sectionInnerHTML.querySelector('[data-cart-count]').textContent;
						});
						document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
							elm.textContent = sectionInnerHTML.querySelector('[data-cart-total]').textContent;
						});



						// a11y
						if ( document.getElementById('screen-reader-info') ) {
							document.getElementById('screen-reader-info').innerText = `${KROWN.settings.locales.cart_announcement}`;
							setTimeout(()=>{
								document.getElementById('screen-reader-info').innerText = '';
							}, 1000);
						}

						
					})
					.catch(e => {
						console.log(e);
					})
					.finally(() => {
						// submitButton.classList.remove('working');
					});


}


async function custom_updatecart_fun(updates,added_addon,targetVariantID, timestamp,main_varinat){
  
     await fetch(`${KROWN.settings.routes.cart_update_url}.js`, {
              method: 'POST',
              body: updates
        })
        .then(response => response.json())
        .then(response => {

						// console.log("response.status",response);
						if (response.status == 422 ) {							
              console.log('Request failed');
							return fetch('?section_id=helper-cart');
						} else {
              return fetch('?section_id=helper-cart');
						}
					})
					.then(response => response.text())
					.then(text => {

						const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');

            // console.log("sectionInnerHTML",sectionInnerHTML);

							const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
							const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

							if ( document.getElementById('AjaxCartForm') ) {
								const cartItems = document.getElementById('AjaxCartForm');
								cartItems.innerHTML = cartFormInnerHTML;
								cartItems.ajaxifyCartItems();
								// if ( alert != '' ) {
								// 	document.getElementById('AjaxCartForm').querySelector('form').prepend(alert);
								// }
								document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							}

						

						document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
							elm.textContent = sectionInnerHTML.querySelector('[data-cart-count]').textContent;
						});
						document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
							elm.textContent = sectionInnerHTML.querySelector('[data-cart-total]').textContent;
						});



						// a11y
						if ( document.getElementById('screen-reader-info') ) {
							document.getElementById('screen-reader-info').innerText = `${KROWN.settings.locales.cart_announcement}`;
							setTimeout(()=>{
								document.getElementById('screen-reader-info').innerText = '';
							}, 1000);
						}

						
					})
					.catch(e => {
						console.log(e);
					})
					.finally(() => {
						// submitButton.classList.remove('working');
            if(added_addon && targetVariantID && timestamp && main_varinat){
              addtocatycust(targetVariantID,timestamp,main_varinat)
            }
					});
}



// async function syncFeeProduct() {

//   const MAIN_HANDLE = 'gewurzbox-mit-individuellem-etikett';
//   console.log("MAIN_HANDLE",MAIN_HANDLE);
// //   const variants = window.extraFeeVariants || [];
// //   if (!variants.length) return;

// //   const feeVariantIds = variants.map(v => Number(v.id));

// //   const cart = await fetch('/cart.js').then(r => r.json());

// //   const mainItem = cart.items.find(
// //     item => item.handle === MAIN_HANDLE
// //   );

// //   const existingFee = cart.items.find(
// //     item => feeVariantIds.includes(Number(item.variant_id))
// //   );

// //   // Main product removed => remove fee product
// //   if (!mainItem) {

// //     if (existingFee) {
// //       await fetch('/cart/change.js', {
// //         method: 'POST',
// //         headers: { 'Content-Type': 'application/json' },
// //         body: JSON.stringify({
// //           id: existingFee.key,
// //           quantity: 0
// //         })
// //       });

// //       window.refreshCart?.();
// //     }

// //     return;
// //   }

// //   const qty = parseInt(mainItem.quantity);

// //   const targetTitle =
// //     qty >= 84 ? '84' :
// //     qty >= 72 ? '72' :
// //     qty >= 60 ? '60' :
// //     qty >= 48 ? '48' :
// //     qty >= 36 ? '36' :
// //     qty >= 24 ? '24' :
// //     null;

// //   // Qty less than 24 => remove fee product
// //   if (!targetTitle) {

// //     if (existingFee) {
// //       await fetch('/cart/change.js', {
// //         method: 'POST',
// //         headers: { 'Content-Type': 'application/json' },
// //         body: JSON.stringify({
// //           id: existingFee.key,
// //           quantity: 0
// //         })
// //       });

// //       window.refreshCart?.();
// //     }

// //     return;
// //   }

// //   const targetVariant = variants.find(
// //     v => v.title.trim() === targetTitle
// //   );

// //   if (!targetVariant) return;

// //   // Correct variant already exists
// //   if (
// //     existingFee &&
// //     Number(existingFee.variant_id) === Number(targetVariant.id)
// //   ) {
// //     return;
// //   }

// //   // // Remove wrong fee variant
// //   // if (existingFee) {
// //   //   await fetch('/cart/change.js', {
// //   //     method: 'POST',
// //   //     headers: { 'Content-Type': 'application/json' },
// //   //     body: JSON.stringify({
// //   //       id: existingFee.key,
// //   //       quantity: 0
// //   //     })
// //   //   });
// //   // }

// //   // // Add correct fee variant
// //   // await fetch('/cart/add.js', {
// //   //   method: 'POST',
// //   //   headers: { 'Content-Type': 'application/json' },
// //   //   body: JSON.stringify({
// //   //     id: targetVariant.id,
// //   //     quantity: 1,
// //   //     properties: {
// //   //       _auto_fee: 'true'
// //   //     }
// //   //   })
// //   // });

// //   // window.refreshCart?.();

// //   console.log(
// //     'Main Qty:',
// //     qty,
// //     'Fee Variant:',
// //     targetVariant.title
// //   );
// }

